export default function collateErrors(values, props, json) {
    let errors = {};
    const { messages } = props;

    if (json && json.errors) {
        let errorMessage;

        json.errors.forEach(({ errorKey, errorParameters }) => {
            switch (errorKey) {
                case '_ERR_AUTHENTICATION_MINIMUMLENGTH_PASSWORD':
                    errorMessage = messages.errors.minLength({ characters: 8 });
                    break;
                case 'ERR_AUTHENTICATION_MAXIMUMLENGTH_PASSWORD':
                    errorMessage = messages.errors.maxLength({ characters: 64 });
                    break;
                case 'ERR_AUTHENTICATION_PASSWORD_IN_PASSWORD':
                    errorMessage = messages.errors.containsPassword();
                    break;
                case '_ERR_AUTHENTICATION_MAXCONSECUTIVECHAR_PASSWORD':
                    errorMessage = messages.errors.characterRepeats({ repeats: 3 });
                    break;
                case '_ERR_AUTHENTICATION_MAXINTANCECHAR_PASSWORD':
                    errorMessage = messages.errors.characterOccurrence({ occurrence: 4 });
                    break;
                case 'ERR_AUTHENTICATION_WHITESPACE_IN_PASSWORD':
                    errorMessage = messages.errors.containsWhitespace();
                    break;
                // value coming back from WCS
                case 'ERR_AUTHENTICATION_BLACKLISTED_PASSWORD':
                    errorMessage = messages.errors.blocklistedPassword();
                    break;
                case '_ERR_AUTHENTICATION_USERIDMATCH_PASSWORD':
                    errorMessage = messages.errors.containsLogonId();
                    break;
                case '_ERR_AUTHENTICATION_REUSEOLD_PASSWORD':
                    errorMessage = messages.errors.reuseOldPassword();
                    break;
                case '_ERR_AUTHENTICATION_MINIMUMDIGITS_PASSWORD': {
                    const occurrence = errorParameters ? errorParameters.split(',')[0] : 1;
                    errorMessage = messages.errors.mustContainNumber({ occurrence });
                    break;
                }
                case '_ERR_AUTHENTICATION_MINIMUMLETTERS_PASSWORD': {
                    const occurrence = errorParameters ? errorParameters.split(',')[0] : 1;
                    errorMessage = messages.errors.mustContainLetter({ occurrence });
                    break;
                }
                case '_ERR_PASSWORDS_NOT_SAME':
                    errorMessage = messages.errors.passwordsDontMatch();
                    break;
            }
        });
        if (errorMessage) {
            errors.logonPassword = errorMessage;
        }
    }

    return errors;
}
